import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const AddReview = createAsyncThunk(
  "review/AddReview",
  async (reviewData, thunkAPI) => {
    try {
      const response = await axios.post(endPoint.AddReviewUser, {
        productId: reviewData?.productId,
        rating: reviewData?.rating,
        comment: reviewData?.comment,
        name: reviewData?.name,
      });
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const AddReviewSlice = createSlice({
  name: "AllData",
  initialState: {
    AllData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AddReview.fulfilled, (state, action) => {
        state.AllData = action.payload;
      })
      .addCase(AddReview.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default AddReviewSlice.reducer;
